
import { defineComponent, onBeforeMount, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import Loader from '@/common/components/UI/Loader/index.vue'
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

import useAccount from '@/common/composable/useAccount'

import locationAPI from '@/new-services/location.service'
import { Warehouse } from '@/new-services/types/location'

const WEEK_DAYS = ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ']

export default defineComponent({
    components: {
        Loader,
        PageTitle,
        TheButton,
        Cheap,
    },
    setup() {
        const router = useRouter()
        const route = useRoute()

        const { havePermissions } = useAccount()

        const warehouseId = Number(route.params.id)

        const state = reactive({
            is_loading: true,
            warehouse: null as Warehouse | null,
        })

        const loadWarehouse = async (id: number) => {
            try {
                state.is_loading = true
                const response = await locationAPI.getWarehouse(id)
                state.warehouse = response.data.data
            } catch (error) {
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        const goEdit = () => router.push(`/warehouses/${warehouseId}/edit`)

        onBeforeMount(() => {
            loadWarehouse(warehouseId)
        })

        return {
            state,
            goEdit,
            loadWarehouse,
            havePermissions,
            warehouseId,
            WEEK_DAYS,
        }
    },
})
